import Loading from '../../common/components/List/Loading.js'
import {
  isLoadingListSelector,
  transferDetailTransferIDSelector,
  getCurrentDetailTransfer,
} from './transferDetailFunctions.js'
import {getState, useSelector} from '../../store.js'
import ButtonLink from '../../common/components/Button/ButtonLink.js'
import Quantity from '../../common/components/Quantity.js'
import {productSelector} from '../../data/products.js'
import PopoverImage from '../../common/components/PopoverImage.js'
// import {showImgsTransferSelector} from '../../data/company.js'
import {showConfirmMessageModal} from '../../common/components/Modal/ConfirmMessageModal.js'
import api from '../../common/api.js'
import {showMessageToast} from '../Header/Toast/index.js'
import {buildPath} from '../../common/querystring.js'
import {transferSelector} from '../../data/transfers.js'
import TextArea from '../../common/components/TextArea.js'
import {TRANSFER_URI_COMPONENT} from '../../common/constants/Transfers.js'
import {showImgsTransferSelector} from '../../data/company.js'

async function editTransferLineNotes(lineID, line_notes) {
  await showConfirmMessageModal({
    title: 'Edit Line Notes',
    Message: ({form, updateModalForm}) => (
      <ul className="list list--no-style">
        <li>
          <TextArea
            label="Explanation"
            rows="10"
            id="comment"
            value={form.confirmValue}
            onChange={(value) => updateModalForm({confirmValue: value})}
            autoFocus
          />
        </li>
      </ul>
    ),
    confirmText: 'Save',
    cancelText: 'Cancel',
    confirmValue: line_notes || '',
    onResolve: async ({outcome}) => {
      if (outcome === false) {
        return
      }

      const transferID = transferDetailTransferIDSelector(getState())

      try {
        await api.put(
          buildPath([TRANSFER_URI_COMPONENT, transferID, 'line', lineID]),
          {
            line_notes: outcome,
          },
        )

        showMessageToast('Updated transfer line notes')

        await getCurrentDetailTransfer()
      } catch (err) {
        throw new Error(
          `Error updating transfer line notes: ${err.error_message || err.message}`,
        )
      }
    },
  })
}

function Row({line}) {
  const showImgsTransfer = useSelector(showImgsTransferSelector)

  const {sku, name} = line
  const product = useSelector((state) => productSelector(state, {sku}))

  if (!product) {
    return null
  }

  return (
    <tr className="table__tr table__tr--mo-row">
      <td className="table__td">
        <div className="flex">
          {showImgsTransfer && (
            <PopoverImage src={product.image_url} alt={name} />
          )}
          <dl className="list">
            <dt className="list__title fs-00 lh-md line-detail margin-bottom-0">
              <a
                className="btn--link darker"
                href={`#/product/${encodeURIComponent(sku)}`}
              >
                <strong className="block margin-bottom-3">{name}</strong>
              </a>
              <div className="block unbold margin-bottom-3">SKU: {sku}</div>
            </dt>
          </dl>
        </div>
      </td>
      <td className="table__td">
        {line.line_notes ? (
          <dd className="list__item--order-data">
            <div className="ws-pre-wrap fs-n0 lh-md">{line.line_notes}</div>
            <ButtonLink
              className="fs-n0"
              onClick={() => editTransferLineNotes(line.id, line.line_notes)}
            >
              Edit
            </ButtonLink>
          </dd>
        ) : (
          <dd className="list__item--order-data">
            <ButtonLink
              className="fs-n0"
              onClick={() => editTransferLineNotes(line.id)}
            >
              Add a note
            </ButtonLink>
          </dd>
        )}
      </td>
      <td className="table__td align-right">
        <strong className="fs-01 lh-md">
          <Quantity value={line.quantity} options={{ifNull: '–'}} />
        </strong>
      </td>
    </tr>
  )
}

function EmptyList({colSpan}) {
  return (
    <tr className="table__tr">
      <td className="table__td" colSpan={colSpan}>
        <div className="padding-top-25 padding-bottom-25 align-center">
          <strong className="text--md-grey fs-02 lh-md">
            There aren’t any Products added to this Transfer.
          </strong>
        </div>
      </td>
    </tr>
  )
}

function Table() {
  const transferID = useSelector(transferDetailTransferIDSelector)
  const transfer = useSelector((state) => transferSelector(state, {transferID}))

  return (
    <table className="table table--zebra-list table--product-list">
      <thead>
        <tr className="table__tr">
          <th className="table__th th-width-30 v-align-middle no-border">
            <span className="fs-00 lh-md">Product</span>
          </th>
          <th className="table__th table__th--sm th-width-40 v-align-middle no-border">
            <span className="fs-00 lh-md">Notes</span>
          </th>
          <th className="table__th th-width-20 align-right v-align-middle no-border">
            <span className="fs-00 lh-md">Qty</span>
          </th>
        </tr>
      </thead>
      <tbody className="table__tbody--full-border">
        {transfer.lines.map((line) => (
          <Row key={line.sku} line={line} transfer={transfer} />
        ))}
        {transfer.lines.length === 0 && <EmptyList colSpan="3" />}
      </tbody>
    </table>
  )
}

export default function List() {
  const isLoadingList = useSelector(isLoadingListSelector)

  return (
    <>
      {isLoadingList ? (
        <div className="medium-12 columns list--empty-content margin-top-40 margin-bottom-40">
          <Loading />
        </div>
      ) : (
        <Table />
      )}
    </>
  )
}
